import localStorage from "legacy/utils/localStorage";

const LOCAL_STORAGE_PREFIX = "control-flow-block-preferences";

const getLocalStorageString = (apiId: string) => {
  return `${LOCAL_STORAGE_PREFIX}-${apiId}`;
};

export const clearLocalBlockState = (apiId: string) => {
  localStorage.removeItem(getLocalStorageString(apiId));
};
